import * as gfunctions from '../../../js/generalFunctions';

CCL.bookingBuddyModal = {
  autoload: [
    ['radioSelect', $('.booking-info').length > 0],
    ['modalEvents', $('#BookingBuddyModal').length > 0]
  ],
  radioSelect() {
    $('body').on('click keypress', '.booking-place-date', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        console.dir();
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').removeClass('show');
      }
    });
    $('body').on('click keypress', '.booked-cruiser-label', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        console.dir(event.currentTarget);
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').addClass('show');
      }
    });
    $('body').on('click keypress', '.logged-out-user-label', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        console.dir(event.currentTarget);
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.booked-cruiser-form').removeClass('show');
        $('.logged-out-user-form').addClass('show');
      }
    });
  },
  modalEvents() {
    const modalEl = $('#BookingBuddyModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-booking-buddy-modal/booking-buddy-modal.js